import { purchaseType } from "../types/index.const";

const purchaseTypeOptions = purchaseType.map((el) => ({
  label: el,
  value: el,
}));

export default purchaseTypeOptions;
